import React from 'react'
import '../styles/cifras.css'

function CifrasComp() {
    return (
        <div className='container-xxxl d-flex justify-content-center align-items-center'>
            <div className='figures-container'>

                <div className='figures-card text-center d-flex flex-column justify-content-center align-items-center'>
                    <div className='figures-card-tittle fw-bold'>16</div>
                    <div className='figures-card-tittle'>Años</div>
                </div>

                <div className='figures-card text-center d-flex flex-column justify-content-center align-items-center'>
                    <div className='figures-card-tittle fw-bold'>+7000</div>
                    <div className='figures-card-tittle'>Asociados</div>
                </div>

                <div className='figures-card text-center d-flex flex-column justify-content-center align-items-center'>
                    <div className='figures-card-tittle fw-bold'>+10</div>
                    <div className='figures-card-tittle'>Áreas del derecho</div>
                </div>

                <div className='figures-card text-center d-flex flex-column justify-content-center align-items-center'>
                    <div className='figures-card-tittle fw-bold'>+15</div>
                    <div className='figures-card-tittle'>Abogados</div>
                </div>

                <div className='figures-card text-center d-flex flex-column justify-content-center align-items-center'>
                    <div className='figures-card-tittle fw-bold'>+5</div>
                    <div className='figures-card-tittles'>Beneficios adicionales</div>
                </div>

            </div>
        </div >
    )
}

export default CifrasComp
